import { Lead } from "../types/LeadTypes";

interface Conversation {
  speaker: "Business" | "Lead";
  text: string;
}

/**
 * Converts the transcription_json format from the API to the format expected by the AudioTranscriptModal component
 * @param lead The lead object containing transcription_json
 * @returns An array of Conversation objects with speaker and text properties
 */
export const formatTranscriptForDisplay = (lead: Lead): Conversation[] => {
  if (!lead.transcription_json) {
    return [];
  }

  // Parse the transcription_json if it's a string
  let transcriptionData;
  if (typeof lead.transcription_json === "string") {
    try {
      transcriptionData = JSON.parse(lead.transcription_json);
    } catch (error) {
      console.error("Error parsing transcription_json:", error);
      return [];
    }
  } else if (Array.isArray(lead.transcription_json)) {
    transcriptionData = lead.transcription_json;
  } else {
    return [];
  }

  // Check if the parsed data is an array and has elements
  if (!Array.isArray(transcriptionData) || transcriptionData.length === 0) {
    return [];
  }

  return transcriptionData.map((item) => ({
    // Map the speaker to either 'Business' or 'Lead'
    speaker:
      item.speaker === "Business"
        ? "Business"
        : ("Lead" as "Business" | "Lead"),
    // Map the message property to text property
    text: item.message,
  }));
};
